import {
  FETCH_HISTORY_SUCCESS,
  FETCH_HISTORY_FAIL,
  FETCH_SUB_HISTORY_SUCCESS,
  FETCH_SUB_HISTORY_FAIL,
  FETCH_ORDER_HISTORY_SUCCESS,
  FETCH_ORDER_HISTORY_FAIL,
  EXPORT_HISTORY_SUCCESS,
  EXPORT_HISTORY_FAIL,
  GENERATE_STATEMENT_SUCCESS,
  GENERATE_STATEMENT_FAIL
} from '../actions/types';

const initialState = {
  history: [],
  pagination: [],
  subHistory: [],
  subPagination: [],
  errors: [],
  success: [],
};

const history = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HISTORY_SUCCESS:
      return {
        ...state,
        history: action.payload.data,
        pagination: action.payload.pagination,
        loading: false,
      };
    case FETCH_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case FETCH_SUB_HISTORY_SUCCESS:
      return {
        ...state,
        subHistory: action.payload.data,
        subPagination: action.payload.pagination,
        loading: false,
      };
    case FETCH_SUB_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case FETCH_ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        history: action.payload.data,
        pagination: action.payload.pagination,
        loading: false,
      };
    case FETCH_ORDER_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case EXPORT_HISTORY_SUCCESS:
      return {
        ...state,
        success: { success: ['Export queued, please check your email'] },
        errors: [],
        loading: false,
      };
    case EXPORT_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
        success: [],
      };
    case GENERATE_STATEMENT_SUCCESS:
      if (action.payload && action.payload.message) {
        return {
          ...state,
          success: { success: ['Your statement is on it\'s way via email']},
          errors: [],
          loading: false,
        };
      }

      return {
        ...state,
        loading: false
      };

    case GENERATE_STATEMENT_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors,
        success: [],
      };
    default:
      return state;
  }
};

export default history;
